
/**
 * Search
 * Class for handling product search
 */
export function execute(args) {
  if (typeof args !== "object") return false;

  // Properties
  let _data = {
    phrase: "",
    category: "",
    params: [],
  };

  if (typeof args.phrase !== "undefined") {
    _data.phrase = args.phrase.trim();

    // Country-specific token replacement

    // Token-replacement
    ["&", "%", "<", ">", ":", "\\", "."].forEach((token) => {
      _data.phrase = _data.phrase.replace(token, "");
    });

    // Trim
    _data.phrase = _data.phrase.trim();
  }

  if (typeof args.filters !== "undefined" && args.filters.length) {
    args.filters.forEach((filter) => {
      Array.from(filter.options).forEach((o) => {
        if (o.selected) {
          _data.params.push([o.dataset.brand, o.value]);
        }
      });
    });
  }

  if (
    typeof args.featurefilters !== "undefined" &&
    args.featurefilters.length
  ) {
    args.featurefilters.forEach((x) => {
      _data.params.push([x.dataset.productFieldName, x.dataset.filterValue]);
    });
  }

  var set = new Set();
  _data.params.forEach((array) => set.add(JSON.stringify(array)));
  _data.params = Array.from(set, (x) => JSON.parse(x));

  if (typeof args.category !== "undefined") {
    _data.category = args.category.trim();
  }

  // Query
  let query = "",
    lastFilter = "";
  for (let i = 0; i < _data.params.length; i++) {
    if (lastFilter != _data.params[i][0]) {
      // !important add new boolean
      if (query.length == 0) {
        query += _data.params[i][0] + equalityseperator;
      } else {
        query += parameterseperator + _data.params[i][0] + equalityseperator;
      }

      lastFilter = _data.params[i][0];
    } else {
      query += listseperator;
    }

    query += _data.params[i][1];
  }

  // Url
  let url = baseurl + query;

  if (_data.category.length > 0) {
    if (url == baseurl) {
      url += categorypathparamname + equalityseperator + _data.category;
    } else {
      url +=
        parameterseperator +
        categorypathparamname +
        equalityseperator +
        _data.category;
    }
  }

  if (_data.phrase.length > 0) {
    if (_data.phrase.indexOf("*") > -1) {
      _data.phrase = _data.phrase.replace("*", "¤asterisk¤");
    }

    if (_data.phrase.indexOf("+") > -1) {
      _data.phrase = _data.phrase.replace("+", "¤plus¤");
    }

    if (url == baseurl) {
      url += searchparamname + equalityseperator + _data.phrase;
    } else {
      const searchParam = parameterseperator + searchparamname + equalityseperator;
      if (url.indexOf(searchParam) > -1) {
        url = url.replace(searchParam, searchParam + _data.phrase);
      } else {
        url += searchParam + _data.phrase;
      }  
    }
  }

    window.location.href = url
      .replace("filterByCategory:", "")
      .replace("filterByCategory!", "");
}